import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'

const TITLE_STYLES =
  'font-body text-body text-base font-normal mb-1 truncate leading-tight'
interface TitleProps {
  className?: string
  style?: React.CSSProperties
}
export const Title: React.FC<PropsWithChildren<TitleProps>> = ({
  children,
  className,
  style,
}) => (
  <h3 className={concatStyles([TITLE_STYLES, className])} style={style}>
    {children}
  </h3>
)

Title.displayName = 'Card.Title'
